import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment/moment';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import { namespace } from 'vuex-class';
import { formatDateAgo } from '@/util/date-util';
import { onErrorImageAvatar } from '@/util/common-util';

const briefingStore = namespace('briefingStore');
@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  components: {},
  methods: {
    onErrorImageAvatar,
    formatDateAgo,
  },
})
export default class ReportFooter extends Vue {
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
}
